import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { SwitchingAccountService } from '../switching-account/switching-account.service';

@Component({
  selector: 'ngc-interstitial-screen',
  templateUrl: './interstitial-screen.component.html'
})
export class InterstitialScreenComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  modalServiceOnHiddenSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  contentServiceHeaderFooterSubscribe: Subscription;
  accountSummaryServiceSubscribe: Subscription;
  contentInterstitialBanner: any;
  deviceTypes: any = [];
  isMobileDevice: boolean;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _deviceTypeHelper: DeviceTypeHelper,
    public switchingAccountService: SwitchingAccountService,
    private accountSummaryDetails: AccountSummaryService,
    private contentService: ContentHeaderFooterService,
    private datalayer: DataLayer,
    private userSession: UserSessionService,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
          if (this.deviceTypes.isMobile) {
            this.isMobileDevice = true;
          }
        });
    }
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                if (data.header.auxiliaryNavigation.get('interstitialBanner')) {
                  this.contentInterstitialBanner =
                    data.header.auxiliaryNavigation.get(
                      'interstitialBanner'
                    ).details;
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
      if (this.userSession.getServiceWorkerCheck()) {
        this.accountSummaryServiceSubscribe = this.getAccountSummary();
      }
    }
  }

  getAccountSummary() {
    return this.accountSummaryDetails
      .getAccountSummaryDetails()
      .subscribe((res) => {
        if (res && res.crprtAgrmntTypeCode) {
          this.accountSummaryDetails
            .getAccountType('edpCorpData')
            .subscribe((resData) => {
              if (resData) {
                if (!!resData && resData.value !== 'P') {
                  this.switchingAccountService.showSwitching();
                  setTimeout(() => {
                    this.switchingAccountService.hideSwitching();
                  }, 3000);
                }
              }
            });
          this.datalayer.setDdcfbData(res);
        }
      });
  }

  ngOnDestroy() {
    // Loadtest ObsUnsub added
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
